module.exports = __webpack_public_path__ + "img/img18.3f439374.svg";